// src/mappers/dashboardMapper.js

const toNumber = (v, fallback = 0) => {
    const n = Number(v)
    return Number.isFinite(n) ? n : fallback
}

const normalizeTx = (tx = {}) => {
    const rawAmount = toNumber(tx.amount, 0)

    const type = String(tx.type || '').toLowerCase()

    let amount = rawAmount
    if (type === 'sent' && rawAmount > 0) amount = -rawAmount
    if (type === 'received' && rawAmount < 0) amount = Math.abs(rawAmount)

    return {
        id: tx.id,
        title: tx.description || tx.reference || 'Transaction',
        amount,
        currency: tx.currency || 'USD',
        status: tx.status || '',
        createdAt: tx.date || tx.created_at || '',
        type,
        raw: tx,
    }
}

export const mapDashboardSummary = (raw = {}) => {

    const wallets = Array.isArray(raw.wallets) ? raw.wallets : []

    // ✅ FIXED: backend returns "stats" not "statistics"
    const s = raw.stats || raw.statistics || {}

    const stats = {
        totalBalance: toNumber(s.totalBalance, 0),
        totalSent: toNumber(s.totalSent, 0),
        totalReceived: toNumber(s.totalReceived, 0),
        transactions: toNumber(s.transactions, 0),
    }

    const recentTransactions = Array.isArray(raw.recentTransactions)
        ? raw.recentTransactions.map(normalizeTx)
        : []

    const chart = Array.isArray(raw.chart) ? raw.chart : []

    return {
        wallets,
        stats,
        recentTransactions,
        chart,
    }
}

export default mapDashboardSummary